import { render } from "./PackageDetailPage.vue?vue&type=template&id=7c01a719"
import script from "./PackageDetailPage.vue?vue&type=script&lang=js"
export * from "./PackageDetailPage.vue?vue&type=script&lang=js"
script.render = render

export default script